var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-nocheck
import { useParams, useHistory } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState, useCallback } from 'react';
import kfetch from '@kareo/kfetch';
import { H3, P } from 'shared-assets/components/Elements/';
import analytics from 'shared-assets/lib/analytics';
import colors from 'shared-assets/lib/colors';
import Icon from 'shared-assets/components/Icon';
import rollbar from 'shared-assets/src/errors/errors';
import TalkingParrotLib from 'shared-assets/components/TalkingParrot/lib';
import TelehealthLogo from 'shared-assets/talking-parrot-ui/components/TelehealthLogo';
import LayoutCentered from './LayoutCentered';
import LoadingUi from './LoadingUi';
import VideoService from './VideoService';
var AuthUi = function () {
    var _a = useParams(), uniqueIdForUrl = _a.uniqueIdForUrl, type = _a.type;
    var _b = useState(null), room = _b[0], setRoom = _b[1];
    var _c = useState(false), verifying = _c[0], setVerifying = _c[1];
    var _d = useState(null), verificationError = _d[0], setVerificationError = _d[1];
    var history = useHistory();
    useEffect(function () {
        var largeRoom = !!type;
        setVerifying(true);
        setRoom(null);
        var url = TalkingParrotLib.authAppointmentUrl({ uniqueIdForUrl: uniqueIdForUrl }, largeRoom);
        kfetch(url.toString())
            .then(function (res) {
            setVerifying(false);
            if (!!res) {
                if (!!res.staticUrl) {
                    window.location.replace(res.staticUrl);
                }
                setVerificationError(null);
                setRoom(__assign({}, res.room));
            }
            else {
                throw new Error('response from talking parrot create or join API is invalid, room not set');
            }
        })
            .catch(function (e) {
            setVerifying(false);
            setVerificationError('Cant validate appointment');
            setRoom(null);
            rollbar.error(e);
        });
    }, [uniqueIdForUrl, type]);
    var videoStatusCallback = useCallback(function (statusType) {
        switch (statusType) {
            case 'leave':
                history.push("/endSession/" + uniqueIdForUrl);
                break;
            case 'ready':
                analytics.track('Room Joined', {
                    name: 'Telehealth',
                    type: 'auth v2',
                    uniqueIdForUrl: uniqueIdForUrl,
                });
                break;
            default:
                break;
        }
    }, [uniqueIdForUrl]);
    return !!room ? (React.createElement(VideoService, { room: room, title: "Telehealth " + uniqueIdForUrl, videoStatusCallback: videoStatusCallback })) : (React.createElement(LayoutCentered, null,
        React.createElement(TelehealthLogo, null),
        React.createElement(LoadingUi, { isLoading: verifying }),
        !!verificationError ? (React.createElement(Card, { style: { width: '100%' } },
            React.createElement(CardContent, null,
                React.createElement(H3, null, "Couldn't start appointment"),
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true },
                        React.createElement(Icon, { type: "attention-alt", fillColor: colors.error })),
                    React.createElement(Grid, { item: true, xs: 11, style: { color: colors.error } },
                        React.createElement(P, { color: colors.error, style: { marginTop: 0, paddingRight: 0 } }, "We couldn't start the appointment session because one of the following reasons:"),
                        React.createElement("ul", null,
                            React.createElement("li", null, "Appointment time is too far, or has expired"),
                            React.createElement("li", null, "Appointment is no longer valid")),
                        React.createElement(P, { color: colors.error, style: { marginTop: 0, paddingRight: 0 } }, "It is recommended you create a new appointment and try again.")))))) : null));
};
export default AuthUi;
